import React from "react";
import styles from "./BoxFilter.module.scss";
import Box from "components/Box/Box";

class BoxFilterResponsive extends React.Component {

    state = {
        open: true
    };

    getInitialState() {
        return { showResults: false };
    }
    
    favoritar = (selectedMkr) => {
        this.props.favoritar(selectedMkr);
    };

    isFavorite = (item) => {
        let existeFavorito = false;
        const { estabelecimentosFavoritos } = this.props;
        for (let i = 0; i < estabelecimentosFavoritos.length; i++) {
            if (estabelecimentosFavoritos[i] === item) {
                existeFavorito = true;
                break;
            }
        }
        return existeFavorito;
    };
    
    Capitalize(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    
    render() {
        let content = null;
        const { selectedMkr, estabelecimentos, userLocation, setSelectedEstabelecimento } = this.props;
        if(selectedMkr){        
            content =  <Box 
                            item={selectedMkr} 
                            isFavorite={this.isFavorite(selectedMkr)}
                            favoritar ={() => {this.favoritar(selectedMkr)}}
                            userLocation={userLocation}
                            setSelectedEstabelecimento={setSelectedEstabelecimento}
                            estabelecimentosFavoritos={
                                this.props.estabelecimentosFavoritos
                            }
                        />
        }
        else if(estabelecimentos){
            let res = [];
            for (let i = 0; i < 10; i++) {
                const estabelecimento = estabelecimentos[i];
                res.push(
                    <Box 
                        key={i}
                        item={estabelecimento} 
                        favoritar ={() => {this.favoritar(estabelecimento)}}
                        isFavorite={this.isFavorite(estabelecimento)}
                        userLocation={userLocation}
                        setSelectedEstabelecimento={setSelectedEstabelecimento}
                        estabelecimentosFavoritos={
                            this.props.estabelecimentosFavoritos
                        }
                        selectedMkr={this.props.selectedMkr}
                    />
                )
            }
            content = res 
        } 

        return (
            <div className={styles.boxFilter}>
                <div className={styles.borderTop}>&nbsp;</div>
                    <div className={styles.boxFilterResult}>
                        {content}
                    </div>
            </div>
        )
    }
}

export default BoxFilterResponsive;
